import React, { useEffect, useState } from "react";
import { Link, useMatch } from "react-router-dom";

import type { OrganizationSelectFragment } from "./gql/Fragment.generated";
type OrganizationType = OrganizationSelectFragment["organizations"][number];

import styles from "../style.module.scss";
import { useRoutes } from "utils/routes";
import {
  useCurrentOrganization,
  useCurrentUser,
} from "providers/WithCurrentOrganization";
import Button from "ui/Button";
import { CaretIcon } from "ui/Icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";

const OrganizationSelect: React.FunctionComponent = () => {
  const { organizations } = useCurrentUser();
  const currentOrganization = useCurrentOrganization(true);
  const organizationSlug = currentOrganization?.slug;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [organizationSlug]);

  return (
    <li className={styles.selectMenu} data-select-menu="organization">
      <Button bare onClick={() => setOpen(!open)}>
        <small>Organization</small>
        <div className={styles.selectMenuCurrent}>
          {currentOrganization && (
            <span key="name">{currentOrganization.name}</span>
          )}
          {!currentOrganization && [<span key="name">(no organization)</span>]}
          <CaretIcon direction={open ? "up" : "down"} />
        </div>
      </Button>
      {open && (
        <>
          <ul className={styles.selectMenuList}>
            {organizations.map((o) => (
              <OrganizationItem
                key={o.id}
                organization={o}
                onClick={() => {
                  setOpen(!open);
                }}
              />
            ))}
          </ul>
          <ul className={styles.selectMenuList}>
            <AddOrganization />
          </ul>
        </>
      )}
    </li>
  );
};

const AddOrganization: React.FunctionComponent = () => {
  const { organizationsNew } = useRoutes();
  return (
    <li key="new">
      <Link className={styles.selectMenuListItem} to={organizationsNew()}>
        <FontAwesomeIcon
          icon={faPlus}
          className="text-[10px] mr-[2px] -mt-1 hover:text-[#fff] active:text-[#fff]"
        />
        <span className="ml-[4px] hover:text-[#fff] active:text-[#fff]">
          Add Organization
        </span>
      </Link>
    </li>
  );
};

const OrganizationItem: React.FunctionComponent<{
  organization: OrganizationType;
  onClick: () => void;
}> = ({ organization, onClick }) => {
  const { organization: organizationRoute, queryByFingerprint } = useRoutes();
  const queryZoom = useMatch("/queries/:fingerprint");
  return (
    <li key={organization.id}>
      <Link
        className={styles.selectMenuListItem}
        to={
          queryZoom
            ? queryByFingerprint(queryZoom.params.fingerprint, {
                organization: organization.slug,
              })
            : organizationRoute(organization.slug)
        }
        onClick={onClick}
      >
        <span key="name">{organization.name}</span>
      </Link>
    </li>
  );
};

export default OrganizationSelect;
